// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function defaultValue_set_is_authenticated(_isAuthenticated) {
  
}

function defaultValue_set_is_authenticated_loadable(_is_authenticated_loadable) {
  
}

function defaultValue_set_order_history(_is_authenticated_loadable) {
  
}

function defaultValue_set_user(_user_profile) {
  
}

function defaultValue_set_agreed_docs(param) {
  
}

var defaultValue = {
  is_authenticated: false,
  set_is_authenticated: defaultValue_set_is_authenticated,
  is_authenticated_loadable: /* Init */0,
  set_is_authenticated_loadable: defaultValue_set_is_authenticated_loadable,
  order_history: /* Init */0,
  set_order_history: defaultValue_set_order_history,
  user: undefined,
  set_user: defaultValue_set_user,
  agreed_docs: undefined,
  set_agreed_docs: defaultValue_set_agreed_docs
};

var context = React.createContext(defaultValue);

function useAuthContext(param) {
  return React.useContext(context);
}

export {
  defaultValue ,
  context ,
  useAuthContext ,
}
/* context Not a pure module */
